
import { defineComponent, ref, reactive } from 'vue';
import { thirdPartyDeviceApi } from '@/api';
import { GetThirdPartyDeviceForProjectList } from '@/api/distributor/all.type';
import removeFunc from '@/methods/remove-func';
import List from '@/components/common/list/src/list.vue';
import { ListActionItem } from '@/components/common/list';
import { overlayFormData } from '@/util/system';

export default defineComponent({
    components: { List },
    props: {
        type: {
            type: String,
            default: 'project'
        },
        deviceType: {
            type: String,
            default: 'camera'
        }
    },
    setup(props) {
        // searchKey选择项
        const searchKeyList = [{
            name: 'Location',
            label: WordList.TabelPersonDeviceInHtmlLocation
        }, {
            name: 'Project',
            label: WordList.ProperAllTextProject
        }, {
            name: 'Installer',
            label: WordList.ProperAllTextProjectManager
        }];

        const updateData = ref(0);

        // 搜索条件
        const formData = reactive({
            searchKey: 'Location',
            searchValue: '',
            row: 10,
            page: 1,
            type: props.type,
            deviceType: props.deviceType
        });
        overlayFormData(formData);

        // 表头   迁移name 改成prop,增加 {
        //     name: 'op',
        //         label: WordList.CaptureListTanleAction
        // }
        const column = [
            {
                name: 'Location',
                label: WordList.TabelPersonDeviceInHtmlLocation
            }, {
                name: 'Project',
                label: WordList.ProperAllTextProject
            }, {
                name: 'Installer',
                label: WordList.ProperAllTextProjectManager
            }, {
                name: 'CreateTime',
                label: WordList.CreateTime
            }
        ];

        // 表格数据获取
        const tableData = reactive<GetThirdPartyDeviceForProjectList>({
            row: [],
            detail: [],
            total: 0
        });

        // 获取第三方设备数据
        const getThirdPartyDeviceApi = () => {
            thirdPartyDeviceApi.getThirdPartyDeviceForProjectList({ ...formData }, (res: GetThirdPartyDeviceForProjectList) => {
                tableData.row = res.row;
                tableData.detail = res.detail;
                tableData.total = res.total;
                updateData.value += 1;
            });
        };
        getThirdPartyDeviceApi();

        // 删除
        const deleteThirdPartyDeviceApi = (data: { UUID: string }) => {
            removeFunc(WordList.TabelDeleteText, () => {
                thirdPartyDeviceApi.deleteCommunityThirdPartCamera({ UUID: data.UUID }, getThirdPartyDeviceApi);
            });
        };

        // action操作 迁移备注：这部分不用迁移 主要是为了适配删除触发点击
        const action: ListActionItem[] = [{
            type: 'delete2',
            event(data: { UUID: string }) {
                deleteThirdPartyDeviceApi(data);
            },
            class: 'el-icon-delete delete-icon',
            title: WordList.TabelConfigInHtmlDelete
        }];

        return {
            formData,
            searchKeyList,
            column,
            getThirdPartyDeviceApi,
            tableData,
            deleteThirdPartyDeviceApi,
            action,
            updateData
        };
    }
});
